module.exports = __webpack_public_path__ + "static/img/case6.5bf040a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/case6.png
// module id = UClo
// module chunks = 1